import { createContext } from 'react'

export interface AuthState {
  user: User | null
  loading: boolean
  error: boolean
}

export const AuthContext = createContext<AuthState>({ user: null, loading: true, error: false })
